(function () {
  var BAR_DISMISS_KEY = 'article-calling-lola-bar-dismissed';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-article-calling]').forEach(init);

  function init(root) {
    var body = root.querySelector('[data-article-calling-body]');
    if (!body) return;

    removeEmptyBlocks(body);
    markDropCap(body);
    initCarousel(root.querySelector('[data-article-calling-carousel]'));

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2')).filter(function (h) {
      return h.textContent.trim() !== '';
    });
    var hasToc = headings.length >= 2;

    var tocAside = root.querySelector('[data-article-calling-toc]');
    var tocList = root.querySelector('[data-article-calling-toc-list]');
    var sheet = root.querySelector('[data-article-calling-sheet]');
    var sheetList = root.querySelector('[data-article-calling-sheet-list]');
    var sheetOpen = root.querySelector('[data-article-calling-sheet-open]');
    var counts = Array.prototype.slice.call(root.querySelectorAll('[data-article-calling-toc-count]'));
    var progressBar = root.querySelector('[data-article-calling-progress]');
    var bar = root.querySelector('[data-article-calling-bar]');
    var barClose = root.querySelector('[data-article-calling-bar-close]');
    var end = root.querySelector('[data-article-calling-end]');

    var links = [];
    var activeIndex = -1;

    // ---------- Table of contents (built from the article's H2s) ----------
    if (hasToc) {
      var usedIds = {};
      headings.forEach(function (heading, index) {
        if (!heading.id) {
          heading.id = uniqueId(slugify(heading.textContent), usedIds);
        }
        usedIds[heading.id] = true;

        if (tocList) links.push(buildLink(tocList, heading, index));
        if (sheetList) links.push(buildLink(sheetList, heading, index));
      });

      if (tocAside) tocAside.hidden = false;
      if (sheetOpen) sheetOpen.hidden = false;
    }

    function buildLink(list, heading, index) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      var num = document.createElement('span');
      a.className = 'article-calling-lola__toc-link';
      a.href = '#' + heading.id;
      a.setAttribute('data-index', String(index));
      num.className = 'article-calling-lola__toc-num';
      num.textContent = pad(index + 1);
      a.appendChild(num);
      a.appendChild(document.createTextNode(heading.textContent.trim()));
      a.addEventListener('click', function (event) {
        event.preventDefault();
        var fromSheet = sheet && sheet.contains(a);
        if (fromSheet && sheet.open) sheet.close();
        // Let the sheet finish closing (body scroll unlocks) before
        // scrolling to the target section.
        window.requestAnimationFrame(function () {
          heading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          if (history.replaceState) history.replaceState(null, '', '#' + heading.id);
        });
      });
      li.appendChild(a);
      list.appendChild(li);
      return a;
    }

    function setActive(index) {
      if (index === activeIndex) return;
      activeIndex = index;
      links.forEach(function (link) {
        var isActive = Number(link.getAttribute('data-index')) === index;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
      var label = hasToc ? pad(Math.max(index, 0) + 1) + ' / ' + pad(headings.length) : '';
      counts.forEach(function (el) {
        el.textContent = label;
      });
    }

    // ---------- Floating bar ----------
    var barDismissed = false;
    try {
      barDismissed = window.sessionStorage.getItem(BAR_DISMISS_KEY) === 'true';
    } catch (e) {
      barDismissed = false;
    }
    var barVisible = false;

    function setBarVisible(visible) {
      if (!bar || visible === barVisible) return;
      barVisible = visible;
      bar.classList.toggle('is-visible', visible);
      // Tells the rest of the page (scroll-top-lola) that the bar is on
      // screen and how tall it is, so the button can move above it.
      var barInner = bar.querySelector('.article-calling-lola__bar-inner') || bar;
      document.documentElement.style.setProperty('--acl-bar-height', barInner.offsetHeight + 'px');
      document.documentElement.classList.toggle('has-acl-bar', visible);
      if (visible) {
        bar.removeAttribute('inert');
        bar.setAttribute('aria-hidden', 'false');
      } else {
        bar.setAttribute('inert', '');
        bar.setAttribute('aria-hidden', 'true');
      }
    }

    if (barClose) {
      barClose.addEventListener('click', function () {
        barDismissed = true;
        try {
          window.sessionStorage.setItem(BAR_DISMISS_KEY, 'true');
        } catch (e) {
          /* storage unavailable: dismissed for this page view only */
        }
        setBarVisible(false);
      });
    }

    // ---------- Mobile TOC sheet ----------
    if (sheet && sheetOpen && typeof sheet.showModal === 'function') {
      sheetOpen.addEventListener('click', function () {
        sheet.showModal();
        sheetOpen.setAttribute('aria-expanded', 'true');
        var active = sheet.querySelector('.is-active') || sheet.querySelector('a');
        if (active) active.focus();
      });

      sheet.addEventListener('close', function () {
        sheetOpen.setAttribute('aria-expanded', 'false');
      });

      // Click on the backdrop (outside the sheet's box) closes it.
      sheet.addEventListener('click', function (event) {
        if (event.target === sheet) {
          var rect = sheet.getBoundingClientRect();
          var inside =
            event.clientX >= rect.left && event.clientX <= rect.right &&
            event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) sheet.close();
        }
      });

      var sheetClose = sheet.querySelector('[data-article-calling-sheet-close]');
      if (sheetClose) {
        sheetClose.addEventListener('click', function () {
          sheet.close();
        });
      }
    } else if (sheetOpen) {
      // No <dialog> support: hide the button rather than ship a broken one.
      sheetOpen.hidden = true;
    }

    // ---------- Scroll-driven state (progress, active section, bar) ----------
    var ticking = false;

    function update() {
      ticking = false;
      var viewport = window.innerHeight;
      var bodyRect = body.getBoundingClientRect();

      // Reading progress across the article body only.
      var total = bodyRect.height - viewport * 0.5;
      var read = total > 0 ? (-bodyRect.top + viewport * 0.25) / total : 0;
      read = Math.min(1, Math.max(0, read));
      if (progressBar) progressBar.style.transform = 'scaleX(' + read.toFixed(4) + ')';

      if (hasToc) {
        var offset = getStickyOffset() + 40;
        var current = 0;
        for (var i = 0; i < headings.length; i++) {
          if (headings[i].getBoundingClientRect().top <= offset) current = i;
        }
        setActive(current);
      }

      if (bar) {
        var endTop = end ? end.getBoundingClientRect().top : Infinity;
        var show = !barDismissed && read > 0.15 && endTop > viewport * 0.85;
        setBarVisible(show);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    function getStickyOffset() {
      var value = parseFloat(getComputedStyle(root).getPropertyValue('--acl-sticky-offset'));
      return isNaN(value) ? 112 : value;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    if (hasToc) setActive(0);
    update();
  }

  // Leftovers from the editor (an emptied quote, blank paragraphs)
  // would otherwise render as empty framed boxes or extra gaps.
  function removeEmptyBlocks(body) {
    var media = 'img, video, iframe, svg, picture, object, embed, hr, table';
    Array.prototype.slice
      .call(body.querySelectorAll('blockquote, p, h2, h3, h4'))
      .forEach(function (el) {
        if (el.textContent.replace(/\u00a0/g, ' ').trim() === '' && !el.querySelector(media)) {
          el.parentNode.removeChild(el);
        }
      });
  }

  // Drop cap goes on the first paragraph that is real running text —
  // not an image-only paragraph and not a fully italic note (e.g. a
  // "fictional scene" disclaimer or a research date line).
  function markDropCap(body) {
    if (!body.classList.contains('article-calling-lola__body--drop-cap')) return;
    var paragraphs = Array.prototype.slice.call(body.children).filter(function (el) {
      return el.tagName === 'P';
    });
    for (var i = 0; i < paragraphs.length; i++) {
      var p = paragraphs[i];
      var text = p.textContent.trim();
      if (!text) continue;
      var only = p.children.length === 1 ? p.children[0] : null;
      var isNote = only && /^(EM|I|SMALL)$/.test(only.tagName) && only.textContent.trim() === text;
      if (isNote) continue;
      if (!/^[A-Za-zÀ-ÿ0-9„"«]/.test(text)) continue;
      p.classList.add('is-drop-cap');
      return;
    }
  }

  // Product carousel: native scroll-snap does the sliding (swipe, trackpad,
  // keyboard scrolling); JS only wires the arrows/dots and keeps them in
  // sync with whichever slide is in view. No autoplay.
  function initCarousel(carousel) {
    if (!carousel) return;
    var track = carousel.querySelector('[data-article-calling-track]');
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-article-calling-slide]'));
    var dots = Array.prototype.slice.call(carousel.querySelectorAll('[data-article-calling-dot]'));
    var prev = carousel.querySelector('[data-article-calling-prev]');
    var next = carousel.querySelector('[data-article-calling-next]');
    if (!track || slides.length < 2) return;

    var current = 0;

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function sync() {
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      index = Math.max(0, Math.min(slides.length - 1, index));
      if (index === current && dots[index] && dots[index].classList.contains('is-active')) return;
      current = index;
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      slides.forEach(function (slide, i) {
        // Off-screen slides leave the tab order and the accessibility tree.
        if (i === index) {
          slide.removeAttribute('inert');
          slide.removeAttribute('aria-hidden');
        } else {
          slide.setAttribute('inert', '');
          slide.setAttribute('aria-hidden', 'true');
        }
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(Number(dot.getAttribute('data-article-calling-dot')));
      });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    carousel.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { goTo(current - 1); }
      if (event.key === 'ArrowRight') { goTo(current + 1); }
    });

    var scrollTick = false;
    track.addEventListener('scroll', function () {
      if (scrollTick) return;
      scrollTick = true;
      window.requestAnimationFrame(function () {
        scrollTick = false;
        sync();
      });
    }, { passive: true });
    window.addEventListener('resize', function () { goTo(current); });

    current = -1;
    sync();
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function slugify(text) {
    var slug = text
      .toLowerCase()
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return slug || 'abschnitt';
  }

  function uniqueId(base, used) {
    var id = base;
    var n = 2;
    while (used[id] || document.getElementById(id)) {
      id = base + '-' + n;
      n++;
    }
    return id;
  }
})();
